import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing, $done } from 'services/activity/action';

export const MODULE = 'Public';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $record = ActionCreator.Async(MODULE, 'Record', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/public/post/record`, payload)
      .then((response) => {
        dispatch($record.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $getManifest = ActionCreator.Async(MODULE, 'Get', (id) => {
  return async (dispatch) => {
    dispatch($processing($getManifest.OPERATION));

    return await Rest.GET(`${API_URL}/public/manifest/${id}`)
      .then((response) => {
        dispatch($getManifest.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getManifest.OPERATION)));
  };
});

export const $startTrip = ActionCreator.Async(MODULE, 'Start', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/public/manifest/trip/start`, payload)
      .then((response) => {
        dispatch($startTrip.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $finishTrip = ActionCreator.Async(MODULE, 'Finish', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/public/manifest/trip/complete`, payload)
      .then((response) => {
        dispatch($finishTrip.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $shippedTrip = ActionCreator.Async(
  MODULE,
  'Shipped',
  (payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/public/manifest/trip/shipped`, payload)
        .then((response) => {
          dispatch($shippedTrip.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $loadingShipment = ActionCreator.Async(
  MODULE,
  'Loading',
  (payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/public/shipment/loading`, payload)
        .then((response) => {
          dispatch($loadingShipment.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $getShipment = ActionCreator.Async(MODULE, 'Get', (id) => {
  return async (dispatch) => {
    dispatch($processing($getShipment.OPERATION));

    return await Rest.GET(`${API_URL}/public/shipment/${id}`)
      .then((response) => {
        dispatch($getShipment.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getShipment.OPERATION)));
  };
});

export const $download = ActionCreator.Async(
  MODULE,
  'Get.Template',
  (sn) => {
    return async (dispatch) => {
      dispatch($processing($download.OPERATION));

      return await Rest.GET(`${API_URL}/public/template/shipment/${sn}`, {})
        .then((response) => {
          dispatch($download.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($download.OPERATION)));
    };
  }
);
